/**
 * StaffCreateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffCreateReq
 */
export interface StaffCreateReq {
  /** 用户名 */
  username: string
  /** 密码 */
  password: string
  /** 昵称 */
  nickname?: string
  /** 简介 */
  bio?: string
  /** 是否禁用 */
  disabled?: boolean
  /** 是否超级管理员 */
  is_super_admin?: boolean
}

/**
 * StaffCreateReq Schema
 */
export const StaffCreateReqSchema: SchemaDefinition = {
  properties: {
    username: {
      description: '用户名',
      format: 'string',
      maxLength: 20,
      minLength: 3,
      type: 'string',
      label: '用户名',
    },
    password: {
      description: '密码',
      format: 'string',
      maxLength: 32,
      minLength: 6,
      type: 'string',
      label: '密码',
    },
    nickname: {
      description: '昵称',
      format: 'string',
      type: 'string',
      label: '昵称',
    },
    bio: {
      description: '简介',
      format: 'string',
      type: 'string',
      label: '简介',
    },
    disabled: {
      default: false,
      description: '是否禁用',
      format: 'bool',
      type: 'boolean',
      label: '是否禁用',
    },
    is_super_admin: {
      default: false,
      description: '是否超级管理员',
      format: 'bool',
      type: 'boolean',
      label: '是否超级管理员',
    },
  },
  required: ['username', 'password'],
  type: 'object',
}
